/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function BellSimpleZ(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M168,224a8.00039,8.00039,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8.00039,8.00039,0,0,1,168,224Zm52.85352-32.00293A15.80079,15.80079,0,0,1,207.0166,200H48.9834a15.99886,15.99886,0,0,1-13.79688-24.06445C41.124,165.7207,48.20313,146.33594,48.20313,112v-8a79.89888,79.89888,0,0,1,79.79492-80c.2041,0,.40625.001.61035.002,43.66894.32422,79.19629,36.61719,79.19629,80.90235V112c0,34.33789,7.07519,53.72363,13.00976,63.93945A15.87,15.87,0,0,1,220.85352,191.99707ZM156,144a8.00039,8.00039,0,0,0-8-8H125.08008l29.06543-34.87891A7.99925,7.99925,0,0,0,148,88H108a8,8,0,0,0,0,16h22.91992l-29.06543,34.87891A7.99925,7.99925,0,0,0,108,152h40A8.00039,8.00039,0,0,0,156,144Z" />
    </Svg>
  );
}

export default BellSimpleZ;
